const isProduction = process.env.NODE_ENV === 'production'
//  const proUrl = 'http://test-gpt-all.web.guanyingis.com'
//  const proUrl = 'http://test.ever.ai.guanyingis.com'
// const proUrl = 'https://gpt-all.web.shuzhiren.com'//
const proUrl = ''
export const baseUrl = proUrl

// 文件上传地址
export const uploadUrl = `${isProduction ? baseUrl : ''}/gptapi/app/oss/file`
